import Item from '~/shared/src/ci/Item';

import {DATA_RESET_ITEM} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {setElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * resetItem Action
 *
 * @memberOf! Actions
 *
 * @param {string} dataContext
 * @param {number} itemId
 * @param {string[]} [additionalElusiveDataContexts=[]]
 *
 * @return {void}
 */
const resetItem = ( dataContext : string, itemId : number, additionalElusiveDataContexts : string[] = [] ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: DATA_RESET_ITEM,
        dataContext,
        itemId,
        additionalElusiveDataContexts
    } );

    let item : Item = global.data[ dataContext ]?.items[ itemId ];

    if ( item ) {
        item = item.reset().clone();

        // update ElusiveData
        additionalElusiveDataContexts.unshift( dataContext );
        for ( const elusiveDataContext of additionalElusiveDataContexts ) {
            const elusiveData    = getState().elusiveData?.[ elusiveDataContext ],
                  newElusiveData = {
                      ...elusiveData,
                      data: {
                          ...elusiveData?.data,
                          items     : {
                              ...elusiveData?.data?.items,
                              [ item.id ]: ( elusiveData?.data?.items?.[ item.id ] ?? 0 ) + 1
                          },
                          references: elusiveData?.data?.references ?? {}
                      }
                  };

            dispatch( setElusiveData( elusiveDataContext, newElusiveData ) );
        }
    }
}
export type ResetItem = typeof resetItem;

export default resetItem;
